export default __webpack_public_path__ + "static/ministry-f01d3e415dcd3f458195637323ba19e8.png";